import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { CustomButton } from "ui";
import { Col } from "antd";
import { ConfirmationModal, confirmationModalConfigs } from "components/ActionModals/ConfirmationModal";
import { unblockUser } from "services";

export const ActivateUserButton = observer(() => {
  const { actionModals, userCard } = useStores();

  const clickHandler = () => {
    actionModals.open(
      () => (
        <ConfirmationModal
          text="Вы действительно хотите восстановить пользователя?"
          successText="Пользователь восстановлен"
          buttonText="Восстановить"
          calledQuery={() => unblockUser({ id: userCard.card.id })}
          onSuccess={() => {
            setTimeout(() => userCard.fetchCardById(userCard.card.id), 1500);
          }}
        />
      ),
      {
        ...confirmationModalConfigs,
        onClose: () => actionModals.closeAll(),
      }
    );
  };

  return (
    <Col>
      <CustomButton type="default" onClick={clickHandler} tooltip="Восстановить пользователя">
        Восстановить
      </CustomButton>
    </Col>
  );
});
